(() => {
  angular
    .module('gm.common.directives')
    .directive('gmyDropdownMenu', gmyDropdownMenu);

  function gmyDropdownMenu(
    $rootScope,
    GmyUtils
  ) {
    'ngInject';

    return {
      replace: true,
      restrict: 'E',
      scope: {
        flyout: '@?',
        isOpen: '=',
        openHeight: '@?',
      },
      templateUrl: 'modules/common/directives/dropdown-menu/dropdown-menu.html',
      transclude: true,
      link(scope, element) {
        scope.autoHeight = false;

        function getInnerWrapperHeight() {
          const clonedEl = element.clone();

          clonedEl.addClass('dropdown-menu--open');
          clonedEl.height('auto');

          angular.element('body').append(clonedEl);

          const height = clonedEl.find('.dropdown-menu__inner-wrapper').outerHeight();

          clonedEl.remove();

          return height + 2;
        }

        function calcAutoHeight() {
          if (scope.isOpen) {
            scope.autoHeight = getInnerWrapperHeight();
          }
        }

        scope.$watch('isOpen', (isOpen) => {
          if (isOpen) {
            calcAutoHeight();
          }

          scope.$broadcast(`gmy-dropdown-menu:${(isOpen ? 'open' : 'close')}`);

          // propagate event to root scope
          $rootScope.$broadcast(
            `gmy-dropdown-menu:${(isOpen ? 'open' : 'close')}`,
            { height: element[0].scrollHeight }
          );
        });

        const throttleCalcAutoHeight = GmyUtils.throttle(calcAutoHeight, 100);
        element.on('DOMNodeInserted DOMNodeRemoved', throttleCalcAutoHeight);
      }
    };
  }
})();
